<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Active Cloudflare Enterprise Domains
            </h4>
          </div>
          <div class="card-body">
            <div class="loader small_loader" v-if="loading"></div>
            <table id="datatable" v-else-if="!loading" class="table table-striped table-bordered">
              <thead>
              <tr>
                <th>Domain</th>
                <th class="text-center">Server IP</th>
                <th class="text-center">Plan</th>
                <th class="text-center">Is Activated</th>
                <th class="text-center">Activated At</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in sortedDomains" :key="row.id">
                <td>
                  {{ row.domain }}
                </td>
                <td width="10%" class="text-center">
                  {{ row.ip }}
                </td>
                <td width="20%">
                  <template>
                    <div class="d-flex align-items-center">
                      <select v-model="row.cfPlan" class="form-control">
                        <option value="performance_package">Performance Package</option>
                        <option disabled value="security_package">Security Package</option>
                        <option value="performance_and_security_package">Performance & Security Package</option>
                        <option disabled value="maintenance_I">Maintenance I</option>
                        <option disabled value="maintenance_II">Maintenance II</option>
                        <option disabled value="maintenance_III">Maintenance III</option>
                      </select>
                      <span><i @click="selectedIndex = index; action='changePlan';setCFPlanInHostingAccounts(row, true)" title="Save" class="fa fa-save text-primary ml-10 make-cursor-pointer"></i><i v-if="index === selectedIndex && action === 'changePlan'" class="fa fa-spinner fa-spin text-primary ml-10 make-cursor-pointer"></i></span>
                    </div>

                  </template>
                </td>
                <td class="text-center fs-16">
                  <i :class="row.cfEnterprise.status === 'pass' ? 'fa fa-check-circle text-success' : (row.cfEnterprise.status === 'running' ? 'fa fa-spinner fa-spin text-info' : (row.cfEnterprise.status === 'fail' ? 'fa fa-times-circle text-danger' : ''))"></i>
                </td>
                <td class="text-center">{{ parseDate(row.cfEnterprise.activatedAt)}} </td>
                <td class="text-center">
                  <button @click="viewLogs(row.cfEnterprise)" class="btn btn-sm btn-primary">
                    <span><i class="fa fa-eye make-cursor-pointer" title="View Output"></i></span>
                  </button>
                  <button @click="retry(row)" v-if="row.cfEnterprise.status === 'fail'" class="btn btn-sm btn-info ml-5">
                    <span><i class="fa fa-repeat make-cursor-pointer" title="Retry"></i></span>
                  </button>
                  <button v-if="row.cfEnterprise.status === 'pass'" @click="deactivate(row)" class="btn btn-sm btn-danger ml-5">
                    <span><i class="fa fa-trash make-cursor-pointer" title="Deactivate CF Enterprise"></i></span>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="view-log-modal">
      <div class="modal fade" tabindex="-1" role="dialog" id="viewLogsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title text-center">Log Details</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <section class="mt-5" v-if="selectedLog.history !== undefined">
<!--                <code>-->
                  <table class="table notesTable">
                    <thead>
                    <tr>
                      <th class="text-center">Output</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Activated At</th>
                      <th class="text-center">Deactivated At</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in sortedHistory" :key="'note_' + index">
                      <td width="40%" class="text-center" style="word-break: break-all">{{row.output}}</td>
                      <td class="text-center">
                        <span class="badge" :class="{'badge-success': row.status === 'pass', 'badge-danger': row.status === 'fail', 'badge-warning': row.status === 'removed'}">{{ row.status === 'pass' ? 'Activated' : (row.status === 'fail' ? 'Fail' : (row.status === 'removed' ? 'Deactivated' : ''))}}</span>
                      </td>
                      <td class="text-center">{{parseDate(row.activatedAt)}}</td>
                      <td class="text-center">{{parseDate(row.deactivatedAt)}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="row mt-10" v-if="selectedLog.history.length > 0 ">
                    <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                       <b>Page {{pageNum + 1}} of {{pageCount}}</b>
                    </span>
                      <section class="dataTables_paginate paging_full_numbers">
                        <paginate
                            id="notes"
                            :pageCount="pageCount"
                            :clickHandler="goToPage"
                            :prevText="'Prev'"
                            :nextText="'Next'"
                            page-class="page-item"
                            prev-class="page-item"
                            prev-link-class="page-link"
                            next-class="page-item"
                            next-link-class="page-link"
                            page-link-class="page-link"
                            containerClass="pagination">
                        </paginate>
                      </section>
                    </div>
                  </div>
<!--                </code>-->
              </section>
              <code v-else>
                <ol style="list-style: none">
                  <li>{{selectedLog.output}}</li>
                </ol>
              </code>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import Paginate from 'vuejs-paginate'
import ManualTaskDetailModal from "@/components/Admin/Sales/ManualTaskDetailModal";
import multiSelect from "vue-multiselect";
import ManualTaskModal from "@/components/Admin/Sales/ManualTaskModal";

export default {
  name: "enterprise",
  components: { Paginate },
  computed: {
    pageCount(){
      if(this.selectedLog && this.selectedLog.history && this.selectedLog.history.length > 0) {
        let filteredGroups = this.selectedLog.history
        let l = filteredGroups.length, s = this.pageSize;
        return Math.ceil(l/s);
      }
    },
    sortedHistory() {
      if(!this.selectedLog.history) {
        return []
      }
      const start = this.pageNum * this.pageSize, end = start + this.pageSize;
      const allTasks = this.selectedLog.history.slice(start, end);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return allTasks.sort((a,b)=> new Date(b.activatedAt) - new Date (a.activatedAt))
      // return this.selectedLog.history ? this.selectedLog.history.sort((a, b) => new Date(b.activatedAt) - new Date(a.activatedAt)) : []
    },
    sortedDomains() {
      // console.log('sorted', this.domains.sort((a, b) => new Date(a.activatedAt) - new Date(b.activatedAt)))
      return this.domains.sort((a, b) => {
        if ('activatedAt' in a.cfEnterprise && 'activatedAt' in b.cfEnterprise) {
          return new Date(b.cfEnterprise.activatedAt) - new Date(a.cfEnterprise.activatedAt);
        } else if ('activatedAt' in a.cfEnterprise) {
          // If 'a' has 'activatedAt' and 'b' doesn't, 'a' comes before 'b'
          return -1;
        } else if ('activatedAt' in b.cfEnterprise) {
          // If 'b' has 'activatedAt' and 'a' doesn't, 'b' comes before 'a'
          return 1;
        } else {
          // If neither 'a' nor 'b' has 'activatedAt', maintain the original order
          return 0;
        }
      });
    }
  },
  data() {
    return {
      loading: false,
      domains: [],
      selectedLog: {output: '', },
      listener: null,
      pageNum: 0,
      pageSize: 3,
      selectedIndex: -1,
      action: ''
    }
  },
  beforeDestroy() {
    if(this.listener) {
      this.listener()
    }
  },
  mounted() {
    this.fetchActivatedCfEnterpriseDomains()
  },
  methods: {
    goToPage(pageNum) {
      this.pageNum = pageNum-1;
    },
    viewLogs (log) {
      console.log(log);
      this.selectedLog = log;
      if(this.selectedLog.history) {
        this.selectedLog.history = this.selectedLog.history.reverse()
      }
      this.pageNum = 0;
      this.pageSize = 3;
      /* eslint-disable */
      $("#viewLogsModal").modal("show");
      $(document).ready(function () {
        $(".modal-backdrop").appendTo(".view-log-modal");
      });
      /* eslint-enable */
    },
    parseDate(date) {
      if(!date) {
        return null
      }
      return moment(date).format('DD MMM YYYY, hh:mm a')
    },
    async getCFData(row) {
      try {
        const ref = await db.collection('hostingAccounts').doc(row.uid).get();
        const apiData = {}
        if(ref.exists) {
          const {accounts} = ref.data();
          for(const acc of accounts) {
            if(acc.primary.domain === row.domain) {
              apiData.email = acc.primary.cloudflare.username || '';
              apiData.apikey = acc.primary.cloudflare.apiKey || '';
              break;
            }
            for(const addon of acc.addon) {
              if(addon.domain === row.domain) {
                apiData.email = acc.primary.cloudflare.username || '';
                apiData.apikey = acc.primary.cloudflare.apiKey || '';
                break;
              }
            }
          }
          console.log('final api data', apiData);
        }
        return apiData
      } catch (e) {
        console.log('error while fetching data', e.toString())
      }
    },
    async setCFPlanInHostingAccounts(data, from = false) {
      try {
        if(!data.cfPlan) {
          swal('Error', 'Please select CF Plan first', 'error')
          this.selectedIndex = -1;
          this.action = ''
          return false;
        }
        const ref = await db.collection('hostingAccounts').doc(data.uid).get();
        if(ref.exists) {
          const { accounts } =ref.data();
          for(const row of accounts) {
            if(row.primary.domain === data.domain && row.primary.serverIP === data.ip) {
              row.primary.cloudflarePlan = data.cfPlan;
              break;
            }
            const obj  = row.addon.find(el => el.domain === data.domain && row.primary.serverIP === data.ip);
            if(obj) {
              obj.cloudflarePlan = data.cfPlan
            }
          }
          await db.collection('hostingAccounts').doc(data.uid).update({accounts});
          await db.collection('domains').doc(data.id).update({cfPlan: data.cfPlan});
          if(from) {
            this.action = '';
            this.selectedIndex = -1
            swal('Success', 'Plan has been changed successfully', 'success')
          }
        }
      } catch (e) {
        this.action = '';
        this.selectedIndex = -1
        console.log('error while setting CF plan data', e.toString())
      }
    },
    async deactivate(row) {
      try {
        const apiData= await this.getCFData(row)
        let buttonHtml = '<div>' +
            '<div>Are you sure you want to deactivate Cloudflare Enterprise with following details? </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            `<li><b>Domain:</b> ${row.domain}</li>` +
            `<li><b>IP:</b> ${row.ip}</li>` +
            `<li><b>CF Email:</b> ${apiData.email}</li>` +
            `<li><b>CF API Key:</b> ${apiData.apikey}</li>` +
            // '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Primary + Addons</button></li>' +
            // '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        const result = await swal({
          title: "Deactivate Cloudflare Enterprise!",
          html: buttonHtml,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if(result.value) {
          // this.loading = true;
          const response = await this.$http.post("provider/deactivate_cf_enterprise", {
            grant_type: "token",
            domain: row.domain,
            email: apiData.email || '',
            apiKey: apiData.apikey || '',
            ip: row.ip
          })
          console.log('response', response.data)
          // await this.fetchActivatedCfEnterpriseDomains();
          await this.setCFPlanInHostingAccounts({...row, cfPlan: 'free'})
          swal('Success', 'You have successfully deactivated CF Enterprise for '+row.domain, 'success');
        }
        this.loading = false;
      } catch (e) {
        this.loading = false
        console.log('74', e.toString())
        swal('Error', 'Something went wrong while deactivating CF Enterprise', 'error');
      } finally {
      }
    },
    async retry(data) {
      try {
        console.log('1231', data)
        const apiData = await this.getCFData(data);
        let buttonHtml = '<div>' +
            '<div>Are you sure you want to deactivate Cloudflare Enterprise with following details? </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            `<li><b>Domain:</b> ${data.domain}</li>` +
            `<li><b>IP:</b> ${data.ip}</li>` +
            `<li><b>CF Email:</b> ${apiData.email}</li>` +
            `<li><b>CF API Key:</b> ${apiData.apikey}</li>` +
             '</ul></div>'
        const result = await swal({
          title: "Activate Cloudflare Enterprise!",
          html: buttonHtml,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if(result.value) {
          console.log('api data', apiData);
          const domainRef = await db.collection('domains').where('domain', '==', data.domain).where('ip', '==', data.ip).limit(1).get();
          if(domainRef.size) {
            const {id} = domainRef.docs[0];
            const cfEnterprise = domainRef.docs[0].data().cfEnterprise || {}
            cfEnterprise.status = 'running'
            await db.collection('domains').doc(id).update({cfEnterprise});
          }
          const response = await this.$http.post("provider/activate_cf_enterprise", {
            grant_type: "token",
            domain: data.domain,
            email: apiData.email,
            apiKey: apiData.apikey,
            ip: data.ip
          })
          console.log('response', response)
        }
      } catch (e) {
        console.log('error at 1266', e.toString())
        swal('Error', 'Something went wrong while processing of activating CF Enterprise', 'error');
      } finally {
        this.loading = false;
      }
    },
    async fetchActivatedCfEnterpriseDomains() {
      try {
        this.loading = true;
        this.domains = []
        if($.fn.DataTable.isDataTable( '#datatable' )) {
          $("#datatable").DataTable().destroy();
        }
        this.listener = await db.collection('domains').where('cfEnterprise.status', 'in', ['pass', 'fail', 'running']).onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added'){
              this.domains.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
            if(changeDoc.type === 'modified') {
              this.domains = this.domains.filter(el => el.id !== changeDoc.doc.id)
              this.domains.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
            if(changeDoc.type === 'removed') {
              this.domains = this.domains.filter(el => el.id !== changeDoc.doc.id)
            }
          }); });
        console.log('70', this.domains)
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        setTimeout(() => {
          $("#datatable").DataTable({
            ordering: false,
            retrieve: true,
            language: {
              search: "_INPUT_",
              searchPlaceholder: "Search",
              emptyTable: "No domain exists",
              size: '40'
            }
          });
        }, 1000)
        this.loading = false;
      } catch (e) {
        this.loading = false
        console.log('74', e.toString())
      } finally {
      }
    },
  }
}
</script>

<style scoped>
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}
code .info{
  color: #376c4f;
}
code .danger{
  color: #cf363e;
}
</style>

